var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgEmptyTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.254,
    height: 194.33,
    viewBox: "0 0 200.254 194.33"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kpmg-empty-table_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Rectangle_62",
    "data-name": "Rectangle 62",
    d: "M0 0h33.898v34.01H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "kpmg-empty-table_svg__Rectangle_57",
    x: 59.948,
    y: 42.771,
    width: 91.531,
    height: 114.041,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("style", null, ".kpmg-empty-table_svg__cls-11,.kpmg-empty-table_svg__cls-22,.kpmg-empty-table_svg__cls-23,.kpmg-empty-table_svg__cls-24,.kpmg-empty-table_svg__cls-26,.kpmg-empty-table_svg__cls-8,.kpmg-empty-table_svg__cls-9{fill:none}.kpmg-empty-table_svg__cls-23{stroke:#65a8e8}.kpmg-empty-table_svg__cls-11,.kpmg-empty-table_svg__cls-22,.kpmg-empty-table_svg__cls-23,.kpmg-empty-table_svg__cls-24,.kpmg-empty-table_svg__cls-8,.kpmg-empty-table_svg__cls-9{stroke-linecap:round;stroke-width:1.6px}.kpmg-empty-table_svg__cls-7{fill:#fff}.kpmg-empty-table_svg__cls-8{stroke:#81c1f9}.kpmg-empty-table_svg__cls-9{stroke:#acd6fb}.kpmg-empty-table_svg__cls-11{stroke:#eef7ff}.kpmg-empty-table_svg__cls-24{stroke:#a3d1fe}.kpmg-empty-table_svg__cls-22{stroke:#c0dffe}.kpmg-empty-table_svg__cls-25{stroke:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Illustration_Empty_Search",
    transform: "translate(.915)",
    opacity: 0.799
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "kpmg-empty-table_svg__Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 36.156,
    cy: 6.617,
    rx: 36.156,
    ry: 6.617,
    transform: "translate(66.596 181.096)",
    fill: "#ddeefe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Group_9",
    "data-name": "Group 9",
    transform: "translate(32.77 36.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Rectangle_61",
    "data-name": "Rectangle 61",
    transform: "rotate(90 60.48 80.58)",
    strokeDasharray: "3 3",
    strokeWidth: 1.6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#65a8e8",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-empty-table_svg__cls-25",
    width: 98.291,
    height: 141.059,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-empty-table_svg__cls-26",
    x: 0.8,
    y: 0.8,
    width: 96.691,
    height: 139.459,
    rx: 5.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Rectangle_59",
    "data-name": "Rectangle 59",
    transform: "rotate(-12 79.392 -55.764)",
    strokeWidth: 1.6,
    stroke: "#65a8e8",
    fill: "#ddeefe"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-empty-table_svg__cls-25",
    width: 73.531,
    height: 96.04,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-empty-table_svg__cls-26",
    x: 0.8,
    y: 0.8,
    width: 71.931,
    height: 94.44,
    rx: 5.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Rectangle_60",
    "data-name": "Rectangle 60",
    transform: "rotate(20 -12.628 188.366)",
    fill: "#bddefe",
    stroke: "#65a8e8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-empty-table_svg__cls-25",
    width: 73.531,
    height: 96.04,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-empty-table_svg__cls-26",
    x: 0.5,
    y: 0.5,
    width: 72.531,
    height: 95.04,
    rx: 5.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Group_8",
    "data-name": "Group 8",
    transform: "translate(32.263 12.597)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-65.95 -48.77)",
    filter: "url(#kpmg-empty-table_svg__Rectangle_57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Rectangle_57-2",
    "data-name": "Rectangle 57",
    transform: "translate(65.95 48.77)",
    fill: "#eef7ff",
    strokeWidth: 1.6,
    stroke: "#65a8e8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-empty-table_svg__cls-25",
    width: 73.531,
    height: 96.04,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-empty-table_svg__cls-26",
    x: 0.8,
    y: 0.8,
    width: 71.931,
    height: 94.44,
    rx: 5.2
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "kpmg-empty-table_svg__Rectangle_58",
    "data-name": "Rectangle 58",
    className: "kpmg-empty-table_svg__cls-7",
    width: 63.912,
    height: 86.421,
    rx: 4,
    transform: "translate(6.002 6.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Line_18",
    "data-name": "Line 18",
    className: "kpmg-empty-table_svg__cls-8",
    transform: "translate(11.63 63.401)",
    d: "M0 0h51.021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Line_331",
    "data-name": "Line 331",
    className: "kpmg-empty-table_svg__cls-8",
    transform: "translate(11.63 68.401)",
    d: "M0 0h51.021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Line_20",
    "data-name": "Line 20",
    className: "kpmg-empty-table_svg__cls-8",
    transform: "translate(11.63 79.908)",
    d: "M0 0h51.021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Line_17",
    "data-name": "Line 17",
    className: "kpmg-empty-table_svg__cls-9",
    transform: "translate(11.63 73.654)",
    d: "M0 0h27.762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Line_19",
    "data-name": "Line 19",
    className: "kpmg-empty-table_svg__cls-9",
    transform: "translate(11.63 85.161)",
    d: "M0 0h27.762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Path_117",
    "data-name": "Path 117",
    d: "M7.197 5.099A1.591 1.591 0 005.483 6.54",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Path_118",
    "data-name": "Path 118",
    className: "kpmg-empty-table_svg__cls-11",
    d: "M1.714 0A1.591 1.591 0 000 1.441",
    transform: "rotate(180 33.057 44.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Line_21",
    "data-name": "Line 21",
    className: "kpmg-empty-table_svg__cls-11",
    transform: "translate(66.293 79.048)",
    d: "M0 0v4.502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Line_22",
    "data-name": "Line 22",
    className: "kpmg-empty-table_svg__cls-11",
    transform: "translate(66.293 74.546)",
    d: "M0 0v1.501"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Group_13",
    "data-name": "Group 13",
    transform: "translate(84.977 65.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Path_119",
    "data-name": "Path 119",
    d: "M41.716 28.236a10.028 10.028 0 102.925 7.084 9.971 9.971 0 00-2.925-7.084zm-.945 13.235a8.691 8.691 0 110-12.289 8.63 8.63 0 010 12.289zm0 0",
    transform: "translate(-20.254 -20.876)",
    fill: "#b3d2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Path_120",
    "data-name": "Path 120",
    className: "kpmg-empty-table_svg__cls-7",
    d: "M143.148 54.536a.664.664 0 00-.689 1.134 6.362 6.362 0 011.223.956.659.659 0 00.467.2.64.64 0 00.467-.2.678.678 0 000-.945 7.771 7.771 0 00-1.468-1.146zm0 0",
    transform: "translate(-124.722 -46.775)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Group_1277",
    "data-name": "Group 1277",
    transform: "translate(1.599 1.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Path_124",
    "data-name": "Path 124",
    d: "M32.92 29.794l-8.075-8.074a.678.678 0 00-.945 0l-.323.323-.79-.79a12.765 12.765 0 10-2.336 2.336l.79.79-.323.323a.666.666 0 00-.2.467.623.623 0 00.2.467l8.074 8.074a2.772 2.772 0 003.926-3.915zM4.593 21.542A11.434 11.434 0 0120.764 5.371 11.434 11.434 0 014.593 21.542zm16.882 1.168c.078-.067.145-.145.222-.222l.222-.222.723.723-.445.445zm10.51 10.054a1.45 1.45 0 01-2.035 0l-7.607-7.607 2.035-2.035 7.607 7.607a1.45 1.45 0 010 2.035zm0 0",
    transform: "translate(.1 -.7)",
    fill: "#65a8e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Path_943",
    "data-name": "Path 943",
    fill: "#83b9ec",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-empty-table_svg__cls-25",
    d: "M3.272 13.064a1.257 1.257 0 01-1.255-1.255c0-.703.563-1.274 1.255-1.274.702 0 1.274.571 1.274 1.274 0 .692-.572 1.255-1.274 1.255zm-.945-3.592V8.884c-.021-1.92 1.059-2.83 1.927-3.561.7-.591 1.254-1.058 1.254-1.886 0-1.01-.794-1.743-1.889-1.743-1.036 0-1.706.576-1.706 1.468 0 .162.029.24.072.34l.127.297-.319.05-1.645.255-.209.033-.066-.2a2.874 2.874 0 01-.123-.83C-.25 1.1 1.305-.25 3.62-.25c2.396 0 4.07 1.478 4.07 3.595 0 1.516-.964 2.36-1.815 3.106-.787.69-1.53 1.34-1.53 2.451V9.4l-.241.01-1.518.054-.259.01z",
    transform: "rotate(1 -456.088 644.522)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.62 0C1.443 0 0 1.243 0 3.108c0 .42.11.75.11.75L1.755 3.6a.979.979 0 01-.092-.439c0-1.023.787-1.718 1.956-1.718 1.262 0 2.14.86 2.14 1.993 0 2.12-3.218 2.193-3.182 5.447v.33l1.518-.056v-.256c0-2.504 3.345-2.815 3.345-5.557C7.44 1.39 5.904 0 3.62 0m-.348 10.785a1.014 1.014 0 101.024 1.024c0-.567-.457-1.024-1.024-1.024M3.62-.5c2.544 0 4.32 1.581 4.32 3.845 0 1.629-1.008 2.513-1.899 3.294-.776.68-1.445 1.266-1.445 2.263v.256a.5.5 0 01-.482.5l-1.517.055a.501.501 0 01-.519-.5v-.326c-.021-2.038 1.108-2.99 2.015-3.755.745-.628 1.166-1.016 1.166-1.695 0-.88-.674-1.493-1.639-1.493-.884 0-1.456.478-1.456 1.218 0 .118.016.16.051.242a.5.5 0 01-.382.691l-1.645.256a.502.502 0 01-.552-.336A3.096 3.096 0 01-.5 3.108c0-1.05.415-1.985 1.168-2.633C1.411-.163 2.431-.5 3.62-.5zm-.347 10.785c.84 0 1.524.684 1.524 1.524 0 .83-.684 1.505-1.524 1.505-.83 0-1.505-.675-1.505-1.505 0-.84.675-1.524 1.505-1.524z",
    transform: "rotate(1 -456.088 644.522)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Ellipse_27",
    "data-name": "Ellipse 27",
    transform: "translate(174.579)",
    strokeWidth: 1.6,
    stroke: "#65a8e8",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-empty-table_svg__cls-25",
    cx: 7.878,
    cy: 7.878,
    r: 7.878
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-empty-table_svg__cls-26",
    cx: 7.878,
    cy: 7.878,
    r: 7.078
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Ellipse_28",
    "data-name": "Ellipse 28",
    transform: "translate(163.324 28.512)",
    stroke: "#a3d1fe",
    strokeWidth: 1.6,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-empty-table_svg__cls-25",
    cx: 5.627,
    cy: 5.627,
    r: 5.627
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-empty-table_svg__cls-26",
    cx: 5.627,
    cy: 5.627,
    r: 4.827
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Ellipse_29",
    "data-name": "Ellipse 29",
    transform: "translate(190.335 46.519)",
    stroke: "#c0dffe",
    strokeWidth: 1.6,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-empty-table_svg__cls-25",
    cx: 4.502,
    cy: 4.502,
    r: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-empty-table_svg__cls-26",
    cx: 4.502,
    cy: 4.502,
    r: 3.702
  })), /*#__PURE__*/React.createElement("rect", {
    id: "kpmg-empty-table_svg__Rectangle_65",
    "data-name": "Rectangle 65",
    width: 9.004,
    height: 9.004,
    rx: 2,
    transform: "rotate(45 -159.736 87.041)",
    strokeWidth: 1.6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#65a8e8",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "kpmg-empty-table_svg__Rectangle_66",
    "data-name": "Rectangle 66",
    width: 9.004,
    height: 9.004,
    rx: 2,
    transform: "rotate(74 -93.012 105.05)",
    stroke: "#c0dffe",
    strokeWidth: 1.6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "kpmg-empty-table_svg__Rectangle_67",
    "data-name": "Rectangle 67",
    width: 4.502,
    height: 4.502,
    rx: 2,
    transform: "rotate(9 -1051.055 87.22)",
    stroke: "#a3d1fe",
    strokeWidth: 1.6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Group_24",
    "data-name": "Group 24",
    transform: "translate(37.647 33.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Line_28",
    "data-name": "Line 28",
    className: "kpmg-empty-table_svg__cls-22",
    transform: "translate(0 2.676)",
    d: "M0 0h5.352"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Line_27",
    "data-name": "Line 27",
    className: "kpmg-empty-table_svg__cls-22",
    transform: "rotate(90 1.338 1.338)",
    d: "M0 0h5.352"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Group_25",
    "data-name": "Group 25",
    transform: "translate(30.144 10.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Line_25",
    "data-name": "Line 25",
    className: "kpmg-empty-table_svg__cls-23",
    transform: "translate(0 4.606)",
    d: "M0 0h9.212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Line_26",
    "data-name": "Line 26",
    className: "kpmg-empty-table_svg__cls-23",
    transform: "rotate(90 2.303 2.303)",
    d: "M0 0h9.212"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-empty-table_svg__Group_26",
    "data-name": "Group 26",
    transform: "translate(14.387 40.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Line_25-2",
    "data-name": "Line 25",
    className: "kpmg-empty-table_svg__cls-24",
    transform: "translate(0 3.253)",
    d: "M0 0h6.507"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-empty-table_svg__Line_26-2",
    "data-name": "Line 26",
    className: "kpmg-empty-table_svg__cls-24",
    transform: "rotate(90 1.627 1.627)",
    d: "M0 0h6.507"
  })))));
}

export default SvgKpmgEmptyTable;